<div class="centered-dialog">
    <form>
        <section>
            <je-list (selectionChanged)="onSelectionChanged($event)" [items]="customers$ | async" label="{{ 'CUSTOMERSELECTION.SELECTCUSTOMERLABEL' | translate }}">
                <ng-template let-customer>
                    <div class="p-2 rounded text-black-900 dark:text-gray-300 border border-solid border-black-500 text-left hover:bg-blue hover:text-white">
                        {{ customer.name }}
                    </div>
                </ng-template>
            </je-list>
        </section>
    </form>
</div>
